var map = {
	"./arrow/chevron.svg": 7623,
	"./cart.svg": 2127,
	"./close.svg": 3793,
	"./compare.svg": 5659,
	"./filter.svg": 1341,
	"./forms/file.svg": 1753,
	"./grid.svg": 1346,
	"./heart.svg": 5027,
	"./list.svg": 5891,
	"./restore.svg": 4200,
	"./user.svg": 7256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8131;